<template>
  <v-layout justify="center">
    <v-dialog v-model="updateExists" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">New version available!</v-card-title>
        <v-card-text
          >Click on refresh button to get the new version.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="reloadApp()"
            >Refresh</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      updateExists: false
    }
  },
  created() {
    // Listen for swUpdated event and display refresh dialog as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
  },

  methods: {
    showRefreshUI(e) {
      // Display a dialog inviting the user to refresh/reload the app due
      // to an app update being available.
      setTimeout(() => {
        this.updateExists = true
      }, 2000)
    },
    reloadApp() {
      this.updateExists = false
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .getRegistrations()
          .then(function(registrations) {
            for (let registration of registrations) {
              console.log('Update service worker', registration)
              registration.update()
            }
          })
      }

      window.location.reload(true)
    }
  },
  updated() {
    console.log('************************** Updated')
  }
}
</script>
